import { render, staticRenderFns } from "./MigrationSummaryItemsTable.vue?vue&type=template&id=044d45ee"
import script from "./MigrationSummaryItemsTable.vue?vue&type=script&lang=js"
export * from "./MigrationSummaryItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports